export default "__VITE_ASSET__CMheF59f__"